import { EventViewData } from 'components/eventView/pages/eventData';

export const KonopexEvent: EventViewData = {
    eventId: 'konopex',
    mapId: 'f33e6c1d-bddb-4b2d-86a7-bff0cbbd3a7e',
    guideId: 'f4f917a8-bb57-4a20-a536-e6c917827861',
    mapSettings: {
        standZoom: 0.7
    },
    eventInfo: {
        externalLinkPosition: 'top',
        externalLinkStyle: 'small',
        externalLinkButtonBackground: '#2F4858',
        externalLinkButtonTextColor: '#fff',
        order: {
            wide: [
                'home',
                '8c052c44-2934-4e96-986c-2f4fae0ed6c4',
                'program',
                '97c62228-479c-44af-b1a5-443234797f0e',
                '4dc2952d-f10f-491d-819f-fd187def8564',
                '6942f580-4468-43b9-b7ab-502832a9995e',
                '043af552-a156-4f6b-82ca-997697835f61',
                '...',
                'information',
                'map'
            ],
            primes: ['8c052c44-2934-4e96-986c-2f4fae0ed6c4'],
            normal: [
                'program',
                '97c62228-479c-44af-b1a5-443234797f0e',
                '4dc2952d-f10f-491d-819f-fd187def8564',
                '6942f580-4468-43b9-b7ab-502832a9995e',
                '043af552-a156-4f6b-82ca-997697835f61',
                '...',
                'information'
            ]
        }
    }
};

// Vystavovatelé, Program, Konzultace, Workshopy, Výhodné akce a inzerce, Partneři, Info.
